import type { Org, OrgSettings } from 'types/orgs';

import api from 'helpers/api';

export const fetchOrgSettings = (id: number) => api.get<Org>(`/organizations/${id}`)
  .then(({ data }) => ({ data: data.settings }));

export const updateOrgSettings = (id: number, settings: OrgSettings) => api.patch(`/organizations/${id}/settings`, settings)
  .then(({ data }) => ({ data: data.settings }));
